/* A value that can be shown on the bill: a link in the table's own voice. */
.link {
  padding: 0;
  border: 0;
  background: none;
  color: var(--accent);
  font: inherit;
  font-weight: 650;
  text-decoration: underline;
  text-decoration-style: dotted;
  text-underline-offset: 3px;
  cursor: pointer;
}

.link:hover {
  text-decoration-style: solid;
}

.link:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
  border-radius: 2px;
}

.row {
  display: block;
}

/* The row the highlight belongs to: a rule and a wash, so it is seen without colour alone. */
.rowHere {
  display: block;
  padding: 0 4px;
  border-left: 3px solid var(--accent);
  background: var(--accent-w);
}

.sure {
  color: var(--muted);
  font-size: var(--t-label);
}

.failed {
  margin: 0;
  padding: 8px 14px;
  border-top: 1px solid var(--line-2);
  color: var(--crit);
  font-size: var(--t-label);
}
